import React from "react";

import { IAuthProps } from "./AuthContext";
import withAuth from "./withAuth";

import "../user.css";

class UserInfoDisplay extends React.Component<IAuthProps> {
    public render() {
        if (!this.props.authContext.user) {
            return "";
        }

        return (
            <div className="user-info-block">
                <div className="user-avatar">{this.userNameAvatar(this.props.authContext.user)}</div>
                <div>
                    <div>{this.props.authContext.user.displayName}</div>
                    <div>{this.props.authContext.user.username}</div>
                </div>
            </div>
        );
    }

    private userNameAvatar(user: any) {
        if (!(user.displayName || user.username)) {
            return;
        }

        const parts = (user.displayName || user.username).split(" ");
        let text = parts[0][0].toUpperCase();
        if (parts.length >= 2) {
            text += parts[1][0].toUpperCase();
        }

        return text;
    }
}

export default withAuth(UserInfoDisplay);
